package uz.ferro.erp.feature.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class RegisterBody(
    var email: String?,
    var firstName: String?,
    var lastName: String?,
    var patronymic: String?
)